<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"
    :headers="headers"
    item-key="_id"
  >
    <template v-slot:body.prepend>
      <tr class="totals-row">
        <td>
          <v-btn small icon color="white" @click="() => $emit('click:filter')">
            <v-icon small>
              mdi-filter
            </v-icon>
          </v-btn>
        </td>

        <td colspan="3" />

        <td :class="['text-right', { 'error--text': overview.totalQuantity < 0 }]">
          {{ formatNumber(overview.totalQuantity) }}
        </td>

        <td colspan="3" />
      </tr>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn small icon color="primary" :disabled="readonly" @click="() => $emit('click:edit', item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>

      <v-btn small icon color="error" :disabled="readonly" @click="() => $emit('click:delete', item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>

      <v-tooltip top>
        <template v-slot:activator="tooltipProps">
          <v-btn
            small
            icon
            color="primary"
            @click="() => copyId(item._id)"

            v-bind="tooltipProps.attrs"
            v-on="tooltipProps.on"
          >
            <v-icon small>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:default>
          Copiar _id
        </template>
      </v-tooltip>
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="item.quantity < 0 ? 'error--text': ''">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.refPrice="{ item }">
      {{ formatMoney(item.refPrice, item.currency) }}
    </template>

    <template v-slot:item.loanDueDate="{ item }">
      {{ formatDate(item.loanDueDate) }}
    </template>

    <template v-slot:item.annualFee="{ item }">
      {{ formatPercentage(item.annualFee) }}
    </template>
  </v-data-table>
</template>

<script>
import {
  formatDate,
  formatMoney,
  formatNumber,
  formatPercentage,
} from '@/utils/format-utils';

import copyToClipboard from '@/utils/copy-to-clipboard';

import { getLoanOverview } from './utils/loan-operations-utils';

export default {
  name: 'LoanOperationsDetailsTable',

  inheritAttrs: false,

  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    headers: [
      {
        value: 'actions',
        text: 'Ações',
        sortable: false,
        groupable: false,
        width: '120px',
      },

      {
        value: 'ticker',
        text: 'Ativo',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'operation',
        text: 'Operação',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'refPrice',
        text: 'PU Base',
        align: 'end',
      },

      {
        value: 'loanDueDate',
        text: 'Vencimento',
      },

      {
        value: 'annualFee',
        text: 'Taxa',
        align: 'end',
      },
    ],
  }),

  computed: {
    overview: (vm) => getLoanOverview(vm.$attrs.items ?? []),
  },

  methods: {
    formatDate,
    formatMoney,
    formatNumber,
    formatPercentage,

    copyId(id) {
      try {
        copyToClipboard(id);

        this.$store.dispatch('notification', {
          text: `_id ${id} copiado com sucesso!`,
          status: true,
        });
      } catch (error) {
        this.$store.dispatch('notification', {
          text: `Não foi possível copiar o _id ${id}`,
          status: true,
          color: 'error',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.totals-row td {
  background: #18324f;
  position: sticky;
  top: 32px;

  color: #fff;
  font-weight: 500;

  z-index: 2;
}
</style>
